var _mask, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCreditcard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "creditcard_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 48
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56 0H8a8 8 0 00-8 8v32a8 8 0 008 8h48a8 8 0 008-8V8a8 8 0 00-8-8z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#creditcard_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56 0H8a8 8 0 00-8 8v32a8 8 0 008 8h48a8 8 0 008-8V8a8 8 0 00-8-8z",
    fill: "url(#creditcard_svg__paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M75 138c34.794 0 63-28.206 63-63s-28.206-63-63-63-63 28.206-63 63 28.206 63 63 63z",
    fill: "url(#creditcard_svg__paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13 90c18.225 0 33-14.775 33-33S31.225 24 13 24s-33 14.775-33 33 14.775 33 33 33z",
    fill: "url(#creditcard_svg__paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M85 44c29.271 0 53-23.729 53-53s-23.729-53-53-53S32-38.271 32-9s23.729 53 53 53z",
    fill: "url(#creditcard_svg__paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 14H10a2 2 0 00-2 2v6a2 2 0 002 2h10a2 2 0 002-2v-6a2 2 0 00-2-2z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 14H10a2 2 0 00-2 2v6a2 2 0 002 2h10a2 2 0 002-2v-6a2 2 0 00-2-2z",
    fill: "url(#creditcard_svg__paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12 16h-2v6h2v-6zM16 16h-2v6h2v-6zM20 16h-2v6h2v-6z",
    fill: "#7A3802"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 30H8v2h10v-2zM14 34H8v2h6v-2zM22 34h-6v2h6v-2zM30 34h-6v2h6v-2zM30 30H20v2h10v-2zM42 30H32v2h10v-2zM54 30H44v2h10v-2z",
    fill: "#fff",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "creditcard_svg__paint0_linear",
    x1: -32,
    y1: 24,
    x2: 14.08,
    y2: -37.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060B0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254764"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "creditcard_svg__paint1_linear",
    x1: 38.111,
    y1: 47.278,
    x2: 31.754,
    y2: 29.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "creditcard_svg__paint2_linear",
    x1: -1.676,
    y1: 93.649,
    x2: -8.973,
    y2: 64.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "creditcard_svg__paint3_linear",
    x1: 96.85,
    y1: -9.001,
    x2: 108.57,
    y2: 38.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "creditcard_svg__paint4_linear",
    x1: 22,
    y1: 14,
    x2: 22,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAD961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7955D"
  })))));
}

export default SvgCreditcard;